import MfButton from '@components/branded/MfButton'
import { ChevronLeft } from 'react-feather'
import history from '../../history'

const BackButton = () => {
  return (
    <MfButton size="sm" color="danger" className="btn-left-space" onClick={history.back}>
      <ChevronLeft size={16} /> Back
    </MfButton>
  )
}

export default BackButton
